<script>
  export let router = {}
  import { onMount, onDestroy } from "svelte"
</script>

<style>

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
/* GLOBAL STYLES
-------------------------------------------------- */
/* Padding below the footer and lighter body text */

body {
  padding-top: 3rem;
  padding-bottom: 3rem;
  color: #5a5a5a;
}


/* CUSTOMIZE THE CAROUSEL
-------------------------------------------------- */

/* Carousel base class */
.carousel {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  bottom: 3rem;
  z-index: 10;
}

/* Declare heights because of positioning of img element */
.carousel-item {
  height: 32rem;
}
.carousel-item > img {
  position: absolute;
  top: 0;
  left: 0;
  
  /* max-width: 100%;
  max-height:auto; */
}
.carousel-item .img-fluid {
  max-width:100%;
  max-height:auto;
}
h1 { 
  font-size: 3em;
  font-weight: bold;
  /* text-shadow: 1px 1px 1px #000, 5px 5px 5px grey;  */
}
.txt-shadow {
  text-shadow: 1px 1px 1px #000, 3px 3px 3px grey; 
}
  
.carousel-caption > p {
  font-weight: bold;
  text-decoration-color: blue
}
/* RESPONSIVE CSS
-------------------------------------------------- */

@media (min-width: 40em) {
  /* Bump up size of carousel content */
  p {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.4;
  }
  .carousel-caption {
    margin-bottom: 1.25rem;
    font-size: 1.25rem;
    line-height: 1.4;
  }
}

</style>

<div class="container">

  <div id="carouselExampleCaptions" class="carousel slide slide carousel-fade" data-ride="carousel">

    <ol class="carousel-indicators">
      <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
      <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
      <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
    </ol>

    <div class="carousel-inner">

      <div class="carousel-item active">
        <!-- <img class="bd-placeholder-img mw-100 mh-100 embed-responsive"  src="images/hero.jpg" alt="Work"> -->
        <img class="img-fluid" src="images/hero-1.jpg" alt="Work">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"></rect></svg> -->
        <div class="container">
          <div class="carousel-caption text-left">
            <h1 class="h1 txt-shadow">You know your business</h1>
            <p class="txt-shadow">We know ours. Peace of mind with Ready Collect Solutions.</p>
            <p><a class="btn btn-lg btn-primary bg-primary text-light" href="#/" role="button">Sign up today</a></p>
          </div>
        </div>
      </div>

      <div class="carousel-item">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"></rect></svg> -->
        <img class="img-fluid" src="images/hero8.jpg" alt="Work">
        <div class="container">
          <div class="carousel-caption text-left">
            <!-- <h1 class="txt-shadow">On site all day? <br/>No time at night?</h1> -->
            <h1 class="txt-shadow">On site all day?</h1>
            <h1 class="txt-shadow">No time at night?</h1>
            <p class="txt-shadow">When you don't have time for chasing past due invoices, <br/> let Ready Collect Solutions put in the hard yards for you.</p>
            <p><a class="btn btn-lg btn-primary text-light" href="#/" role="button">Sign up today</a>
            </p>
          </div>
        </div>
      </div>

      <div class="carousel-item">
        <!-- <svg class="bd-placeholder-img" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img"><rect width="100%" height="100%" fill="#777"></rect></svg> -->
        <img class="img-fluid" src="images/hero9.jpg" alt="Work">
        <div class="container">
          <div class="carousel-caption text-right">
            <h1 class="txt-shadow">When facing a deadline</h1>
            <p class="txt-shadow">Let us face your customer with a delicate conversation.</p>
            <p><a class="btn btn-lg btn-primary text-light" href="#/" role="button">Sign up today</a></p>
          </div>
        </div>
      </div>
    </div>

    <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>

    <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
    
  </div>
</div>